import { combineReducers } from 'redux'
import {
  PUSH_ITEM, PUSH_ITEM_REMOTELY, PUSH_ITEM_REMOTELY_FAILURE, PUSH_ITEM_REMOTELY_SUCCESS,
  GET_CART_SUCCESS,
  ADD_CART_TO_CLOSED,
  UPDATE_UI,
  CART_IS_LOADING } from "./action-types.js"; 

const initialState = {
  cart: {},
  closedCarts: [],
  isLoading: false,
  error: "",
  ui: {
    v: 5,
    flags: [
      { id: "gateway", gateway: true, hashkeys: [{ haskey: "empty", pleaseStopThat: false, done: false}] },
      { id: "ifWheelsOnlySuggestKit", ifWheelsOnlySuggestKit: true, counter: 0, pleaseStopThat: false, done: false },
      { id: "showCashRegister", showCashRegister: true, visible: false }
    ]
  }
};

const cartReducer = (state = initialState, action) => {
  if (!state.ui || initialState.ui.v !== state.ui.v
    //this is not the best way to manage reset of the ui...
    || !state.cart.order || !state.cart.order.cartid || !(state.cart.shipToMe || state.cart.shipToShop || state.cart.shipToShopWithFitting)) {
    //state.ui = initialState.ui;
      state.ui.flags = initialState.ui.flags.map(i => {
        var k = state.ui.flags.find(j => i.id in j);
        if (k != null) {
          return k;
        }
        else {
          return i;
        }
      }
    );
    //  state.ui.flags.map((f) => f.showCashRegister ? { ...f, visible: false } : f);
  }

  switch (action.type) {
    case PUSH_ITEM:
      if (action.item.cai) {
        return {
          ...state, cart: { ...(state.cart), items: (state.cart && state.cart.items ? state.cart.items : []).concat(action.item) }
        };
      } else if (action.item.Holes && action.item.Color) {
        return {
          ...state, cart: { ...(state.cart), wheels: (state.cart && state.cart.wheels ? state.cart.wheels : []).concat({ details: action.item, Car: action.item.car }) }
        };
      }
      break;

    case PUSH_ITEM_REMOTELY:
      return { ...state, isFetching: true };
    case PUSH_ITEM_REMOTELY_FAILURE:
      return { ...state, isFetching: false, error: action.error };

    case GET_CART_SUCCESS:
      //console.log("GET_CART_SUCCESS", action.cart.wheels);
      return { ...state, isLoading: false, cart: action.cart };

    case ADD_CART_TO_CLOSED:
      const closedCarts = [...(state.closedCarts || [])];
      return { ...state, closedCarts: [...closedCarts, action.cart.cartid] };
      break;

    case UPDATE_UI:
      return { ...state, ui: action.ui };

    case CART_IS_LOADING:
      //console.log("CART_IS_LOADING", action.isLoading);
      return { ...state, isLoading: action.isLoading };

    default:
      return state;
  }
};

export default cartReducer;